import storageAvailable from '../../../helpers/storage_available';
import { fetchData } from '../../../helpers/base_data_fetcher';

export default function saveSearchData() {
  if (!storageAvailable('localStorage')) {
    return false;
  }
  return Promise.all([
    fetchData('page.search_term'),
    fetchData('page.search.id'),
  ]).then(([searchTerm, searchId]) => {
    if (searchTerm) {
      // this seems to be referred to in the contact js, but is it used?
      window.localStorage.setItem(
        'last_search_term',
        JSON.stringify({
          date_stored: Date.now(),
          term: _sr.page.search_term,
        }),
      );
    }
    if (searchId) {
      // I can't see the anywhere uses this
      window.localStorage.setItem('search_id', JSON.stringify(searchId));
    }
  });
}
